var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6654 9.02473C16.6654 14.0247 9.9987 19.0247 9.9987 19.0247C9.9987 19.0247 3.33203 14.0247 3.33203 9.02473C3.33203 7.25662 4.03441 5.56093 5.28465 4.31068C6.5349 3.06044 8.23059 2.35806 9.9987 2.35806C11.7668 2.35806 13.4625 3.06044 14.7127 4.31068C15.963 5.56093 16.6654 7.25662 16.6654 9.02473Z",
    stroke: "#726C6C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.5248C11.3807 11.5248 12.5 10.4055 12.5 9.02478C12.5 7.64407 11.3807 6.52478 10 6.52478C8.61929 6.52478 7.5 7.64407 7.5 9.02478C7.5 10.4055 8.61929 11.5248 10 11.5248Z",
    stroke: "#726C6C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.ec698d9286ce2f52a6ed7a96f508c0b4.svg";
export { ForwardRef as ReactComponent };